import { graphql } from "~/gql";

export const COPY_RESOURCING = graphql(/* GraphQL */ `
  mutation copyResourcing(
    $resourcingMatterId: Int!
    $targetMatterId: Int!
    $rateReplacements: [RateReplacement!]!
  ) {
    copyResourcing(
      resourcingMatterId: $resourcingMatterId
      targetMatterId: $targetMatterId
      rateReplacements: $rateReplacements
    ) {
      __typename
      id
      title
      currency {
        id
        code
        symbol
      }
      priceOptions {
        id
        estimatedGpm
        estimatedSuggested
        estimatedChosen
        estimatedRangeGpm
        estimatedRangeSuggestedLower
        estimatedRangeSuggestedUpper
        estimatedRangeChosenLower
        estimatedRangeChosenUpper
        fixedGpm
        fixedSuggested
        fixedChosen
        cappedChosen
        cappedGpm
        cappedSuggested
        feeRiskLower
        feeRiskUpper
        topDownFeeTarget
        topDownHoursTarget
        topDownRateDiscount
      }
      disbursements {
        __typename
        autoFocus @client
        id
        name
        amount
        vatStatus
        order
      }
      uplifts {
        __typename
        autoFocus @client
        id
        amount
        type
        order
        baseUplift {
          id
          reason
        }
        includeOnProposal
      }
      discounts {
        __typename
        autoFocus @client
        id
        reason
        amount
        type
        order
      }
      phases {
        id
        title
        description
        order
        tasks {
          id
          order
          title
          createdAt
          phaseId
          updatedAt
          markedComplete
        }
        priceOptions {
          id
          estimatedGpm
          estimatedSuggested
          estimatedChosen
          estimatedRangeGpm
          estimatedRangeSuggestedLower
          estimatedRangeSuggestedUpper
          estimatedRangeChosenLower
          estimatedRangeChosenUpper
          fixedGpm
          fixedSuggested
          fixedChosen
          cappedChosen
          cappedGpm
          cappedSuggested
          topDownFeeTarget
          topDownHoursTarget
          topDownRateDiscount
        }
        work {
          __typename
          id
          phaseId
          timeLower
          timeUpper
          timeSingle
          workEffort
          topDownRateDiscount
          price {
            lower
            upper
            single
          }
          selectedRate {
            id
            description
            amount
            clientId
            feeEarnerId
            feeEarnerLevelId
            currency {
              id
              code
              symbol
            }
          }
          feeEarnerLevel {
            id
            description
            order
          }
          feeEarner {
            id
            name
            feeEarnerLevel {
              id
              description
              order
            }
            rates {
              id
              description
              amount
              clientId
              feeEarnerId
              feeEarnerLevelId
              currency {
                id
                code
                symbol
              }
            }
            practiceArea {
              id
              name
            }
          }
          cost {
            lower
            upper
            single
          }
          costRate
          price {
            lower
            upper
            single
          }
        }
      }
      work {
        __typename
        id
        phaseId
        timeLower
        timeUpper
        timeSingle
        workEffort
        topDownRateDiscount
        price {
          lower
          upper
          single
        }
        selectedRate {
          id
          description
          amount
          clientId
          feeEarnerId
          feeEarnerLevelId
          currency {
            id
            code
            symbol
          }
        }
        feeEarnerLevel {
          id
          description
          order
        }
        feeEarner {
          id
          name
          feeEarnerLevel {
            id
            description
            order
          }
          rates {
            id
            description
            amount
            clientId
            feeEarnerId
            feeEarnerLevelId
            currency {
              id
              code
              symbol
            }
          }
          practiceArea {
            id
            name
          }
        }
        cost {
          lower
          upper
          single
        }
        costRate
        price {
          lower
          upper
          single
        }
      }
      pricingType
      pricingLevel
      pricingTarget
      disbursements {
        ...DisbursementParts
      }
      teamMemberships {
        ...TeamMembershipParts
      }
    }
  }
`);
